import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner } from 'elements'
import { formSubmit } from 'utils/form'
import { getSite, updateSite } from 'redux/modules/model/site'
import { siteDetailsSelector, siteDetailsStatusSelector } from 'redux/selectors'
import { SiteForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'


const COMPONENT_CSS_CLASSNAME = 'site-edit'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class SiteEdit extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    getSite: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    site: PropTypes.object,
    siteDetailsStatus: PropTypes.string.isRequired,
    updateSite: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, getSite, match: { params: { siteId, targetClientId } } } = this.props
    getSite({ clientId,targetClientId, siteId })
  }

  handleSubmit = (values) => {
    const { clientId, history, site, updateSite } = this.props
    const siteId = get(site, 'siteId');
    const targetClientId = get(site, 'clientId');
    const changes = {
      description: values.description,
      address: values.address,
      timeZone: values.timeZone,
      liveVisitGracePeriod: values.liveVisitGracePeriod
    }
    return formSubmit(updateSite, { clientId,targetClientId, siteId, changes })
      .then(() => history.push(ROUTES.SITE))
  };

  render() {
    const { site, siteDetailsStatus } = this.props
    const initialValues = site ? {
      ...site
    } : null

    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.SITE}>&laquo; Back</Link></p>
          <PageContentTitle>Edit a site</PageContentTitle>
          {API_PENDING === siteDetailsStatus && <Spinner />}
          {API_SUCCESS === siteDetailsStatus && <SiteForm initialValues={initialValues} onSubmit={this.handleSubmit} />}
          {API_FAIL === siteDetailsStatus && <h2>Site id is invalid</h2>}
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  site: siteDetailsSelector,
  siteDetailsStatus: siteDetailsStatusSelector
})

export const actions = {
  getSite,
  updateSite
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(SiteEdit)



// WEBPACK FOOTER //
// ./src/pages/site/site-edit/index.js